import { JSONSchema4 } from 'json-schema';
/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface TaxDeclarationSettingsSchemaContract {
  letXpayrollVerifyDocs?: boolean;
  disable80g?: boolean;
  taxCalculationsOnVerifiedProofs?: boolean;
  financialYear?: number | null;
  autoOpenProofWindowForFnf?: boolean;
  autoOpenProofWindowForNewEmployees?: boolean;
  windowDurationForNewEmployees?: number | null;
  freezeXpayrollVerifyDocs?: boolean;
  proofVerificationCompletedAt?: string | null;
  allowEmployeeToUpdateTaxDeductions?: boolean;
  [k: string]: unknown;
}

export default <JSONSchema4>{
  type: 'object',
  properties: {
    letXpayrollVerifyDocs: { type: 'boolean' },
    disable80g: { type: 'boolean' },
    taxCalculationsOnVerifiedProofs: { type: 'boolean' },
    financialYear: { type: ['integer', 'null'] },
    autoOpenProofWindowForFnf: { type: 'boolean' },
    autoOpenProofWindowForNewEmployees: { type: 'boolean' },
    windowDurationForNewEmployees: { type: ['integer', 'null'] },
    freezeXpayrollVerifyDocs: { type: 'boolean' },
    proofVerificationCompletedAt: { type: ['string', 'null'], format: 'date-time' },
    allowEmployeeToUpdateTaxDeductions: { type: 'boolean' },
  },
};
